<template>
<div id="app">
    <router-view/>
</div>
</template>
<script>
    export default {
        data() {
            return {
                
            }
        },
        mounted() {
           document.title = '车智管-政企'
        },
        methods: {
            
        }
    }
</script>
<style lang="scss">
// @import "~@/assets/css/vant-dysmic.css";
@import "~@/styles/reset.scss";
#app{
    font-size: 14px;
}
.wrapper-title {
    font-size: 16px;
}

</style>
